import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import PublicAppShell, { isPublicAppPath } from './PublicAppShell';
import { isCutierHost } from './utils/cutierHost';

(() => {
  try {
    const path = window.location.pathname || '';
    const search = window.location.search || '';
    const cutierHost = isCutierHost();

    // pe-one…/cutier → eigene Cutier-Origin (lokal: /cutier direkt testen)
    const isLocalDev =
      window.location.hostname === 'localhost' ||
      window.location.hostname === '127.0.0.1';
    if (!cutierHost && !isLocalDev && path.startsWith('/cutier')) {
      const q =
        search && search.includes('pwa=cutier')
          ? search
          : search
            ? `${search}&pwa=cutier`
            : '?pwa=cutier';
      window.location.replace(`https://cutier-hub.web.app/${q}`);
      return;
    }

    // Nur auf Cutier-Host Flags setzen — PE One Root startet immer PE One
    if (cutierHost) {
      localStorage.setItem('pe_cutier_pwa', '1');
      localStorage.setItem('pe_standalone_tool', 'cutier');
    }
  } catch {
    /* ignore */
  }
})();

const savedPeTheme = localStorage.getItem('pe-theme');
if (savedPeTheme === 'light') {
  document.documentElement.classList.remove('dark');
} else {
  document.documentElement.classList.add('dark');
}

const rootElement = document.getElementById('root');

if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      {isPublicAppPath() ? <PublicAppShell /> : <App />}
    </React.StrictMode>
  );
} else {
  console.error("Fehler: Root-Element mit der ID 'root' wurde nicht gefunden.");
}
